import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Typography, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout'

import * as AuthActions from '../../../../../../store/actions/auth.action'
import ConfirmationModal from '../../../modal/confirmation-modal'
import { IModal } from '../../../../../interfaces/modal.interface'

const ContentSettingsMenu = ({
  open,
  handleClose,
  anchorEl,
}: {
  open: boolean
  handleClose: () => void
  anchorEl: null | HTMLElement
}) => {
  const dispatch = useDispatch()

  const [modalOptions, setModalOptions] = useState<IModal>({
    isModalOpen: false,
    title: 'Confirmation',
    message: 'Your account will be logged out of the portal. Are you sure you want to proceed?',
    onClickModal: (e: string) => onModalAction(e),
  })

  const openModal = () => {
    setModalOptions((p) => ({
      ...p,
      isModalOpen: true,
    }))
  }

  const onModalAction = (e: string) => {
    setModalOptions((p) => ({ ...p, isModalOpen: false }))

    if (e === 'confirm') dispatch(AuthActions.Logout())
  }

  return (
    <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
      <MenuItem onClick={openModal}>
        <ListItemIcon>
          <LogoutIcon sx={{ fontSize: '1rem' }} fontSize='small' />
        </ListItemIcon>
        <ListItemText>
          <Typography sx={{ fontSize: '0.75rem' }}>Logout</Typography>
        </ListItemText>
      </MenuItem>

      <ConfirmationModal
        isModalOpen={modalOptions.isModalOpen}
        title={modalOptions.title}
        message={modalOptions.message}
        onClickModal={modalOptions.onClickModal}
      />
    </Menu>
  )
}

export default ContentSettingsMenu
